import "../scss/page.scss";

import "../scss/outsourcing-landing.scss";

import "./scripts/dm-marketing/navbar.js";
import "./scripts/slick-carousel.js";
//import "./scripts/slick/default.js";
import "./scripts/outsourcing-carousel.js";
import "./scripts/outsourcing/developer-slider.js";
import "./scripts/outsourcing/talent.js";
import "./scripts/backstage";
import "./scripts/outsourcing/read-more.js";
import "./scripts/calculatepadding.js";

import * as bootstrap from 'bootstrap';
const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
